export default __webpack_public_path__ + "static/media/redSmall.9248cd75.svg";